<template>
  <div class="container">
    <NavigationBar/>
    <div class="header-video">
      <AboutVideoComponent/>
    </div>
  </div>
  <AboutPrimaryComponent/>
  <div class="container">
    <AboutSecondComponent
        :name="$t('about-second-stoyanka-name')"
        :title="$t('about-second-stoyanka-title')"
        :content="$t('about-second-stoyanka-content')"
        :image="tanyaImg"
    />
    <AboutSecondComponent
        :name="$t('about-second-ivaylo-name')"
        :title="$t('about-second-ivaylo-title')"
        :content="$t('about-second-ivaylo-content')"
        :image="ivayloImg"
    />
  </div>
  <AboutTeamComponent :teamMembers="teamMembers"/>
  <AboutTimelineComponent/>
  <AboutTeamComponent :teamMembers="advisoryMembers"/>
  <div class="container mt-5" v-if="locale === 'bg'">
    <div class="help-title my-5">
      <div class="text-center">
        Къде да потърся помощ?
      </div>
      <div class="text-center">
        Ако имате съмнения за следродилна депресия или симптомите ви се засилват, не се колебайте да се обърнете към
        специалист.
      </div>
    </div>
    <div class="mb-4" v-for="(resource, index) in helpResources" :key="index">
      <AboutHelpComponent
          :title="resource.title"
          :content="resource.content"
          :link="resource.link"
          :phone="resource.phone"
      />
    </div>
  </div>
  <FooterComponent/>
</template>

<script setup>
import NavigationBar from '@/components/NavigationBar.vue';
import FooterComponent from '@/components/Components/FooterComponent.vue';
import AboutVideoComponent from "@/components/Components/About/AboutVideoComponent.vue";
import AboutPrimaryComponent from "@/components/Components/About/AboutPrimaryComponent.vue";
import AboutSecondComponent from "@/components/Components/About/AboutSecondComponent.vue";
import ivayloImg from '@/assets/images/team/ivaylo.png'
import tanyaImg from '@/assets/images/team/tanya.png'
import AboutTeamComponent from "@/components/Components/About/AboutTeamComponent.vue";
import AboutTimelineComponent from "@/components/Components/About/AboutTimelineComponent.vue";
import AboutHelpComponent from "@/components/Components/About/AboutHelpComponent.vue";
import {useI18n} from "vue-i18n";
import {ref} from 'vue';

const {locale, t} = useI18n();

// Bulgarian team members data
const teamMembersBg = [
  {
    firstName: 'Женя',
    lastName: 'Димитрова',
    title: 'Основател и водещ на екипа',
    description: '13+ години опит; Основател на Namiram.bg; бивш Директор Маркетинг и продажби в международна компания ;майка и застъпник на психичното здраве',
    image: '/static/team/zhenya.png',
    linkedin: 'https://www.linkedin.com/in/zhenya-dimitrova-2ab92545/'
  },
  {
    firstName: 'Ивайло',
    lastName: 'Димитров',
    title: 'Основател и технологичен ръководител',
    description: '12+ г. опит като софтуерен инженер ; Приложения за Fortune 500; Технически директор на на Namiram.bg; Управляващ партньор в Intera Digital',
    image: '/static/team/ivaylo.png',
    linkedin: 'https://www.linkedin.com/in/ivaylodimitrovv/'
  },
  {
    firstName: 'доц. Таня',
    lastName: 'Черкезова',
    title: 'Основател и ръководител на изследванията',
    description: '16+ години опит; Социален учен, Доцент, част от управленския екипа на ИИНЧ към БАН',
    image: '/static/team/tanya.png',
    linkedin: 'https://www.linkedin.com/in/stoyanka-cherkezova-mateva-676520b9'
  },
  {
    firstName: 'Добрин',
    lastName: 'Стефанов',
    title: 'Старши Графичен Дизайнер',
    description: '12+ години опит в UI/UX ,Управляващ партнъор в Intera Digital',
    image: '/static/team/dobrin.jpg',
    linkedin: 'https://www.linkedin.com/in/dobrin-stefanov/'
  },
  {
    firstName: 'Стефани',
    lastName: 'Димитрова',
    title: 'Маркетинг експерт',
    description: '8+ години маркетинг опит; бранд стратегии за растеж на компании с принос; Маркетинг стратегии за стартиращи компании',
    image: '/static/team/stefani.jpg',
    linkedin: 'https://www.linkedin.com/in/stefani-dimitrova/'
  },
  {
    firstName: 'Анна',
    lastName: 'Жукивская',
    title: 'Психотерапевт-съветник',
    description: 'Сертифициран семеен терапевт, член на управителния съвет на Българска Асоциация по фамилна терапия. Мениджър на програмата за психологическа подкрепа към Фондация Single Step.',
    image: '/static/team/Anna-Joukivskaia.jpg',
    linkedin: 'https://www.linkedin.com/in/anna-joukivskaia-gmbpss-8437503a/'
  },
  {
    firstName: 'Пабло',
    lastName: 'Маккейб',
    title: 'Съветник',
    description: 'Бивш вицепрезидент в Talkspace - водеща психологическа платформа в Америка',
    image: '/static/team/pablo.jpeg',
    linkedin: 'https://www.linkedin.com/in/pablo-mccabe-9974a41/'
  },
  {
    firstName: 'Красимир',
    lastName: 'Кехайов',
    title: 'Финансов съветник',
    description: 'Партньор в DYNAX Invest, бивш анализатор в Goldman Sachs и стартъп скаут в Innovation Capital.',
    image: '/static/team/krasi.jpeg',
    linkedin: 'https://www.linkedin.com/in/krasimirkehayov/'
  }
];

// English team members data
const teamMembersEn = [
  {
    firstName: 'Zhenya',
    lastName: 'Dimitrova',
    title: 'Founder and Team Lead',
    description: '13+ years of experience; Founder of Namiram.bg; former Marketing and Sales Director in an international company; mother and mental health advocate',
    image: '/static/team/zhenya.png',
    linkedin: 'https://www.linkedin.com/in/zhenya-dimitrova-2ab92545/'
  },
  {
    firstName: 'Ivaylo',
    lastName: 'Dimitrov',
    title: 'Founder and Technology Lead',
    description: '12+ years of experience as a software engineer; Applications for Fortune 500; Technical Director of Namiram.bg; Managing Partner at Intera Digital',
    image: '/static/team/ivaylo.png',
    linkedin: 'https://www.linkedin.com/in/ivaylodimitrovv/'
  },
  {
    firstName: 'Assoc. Prof. Tanya',
    lastName: 'Cherkezova',
    title: 'Founder and Research Lead',
    description: '16+ years of experience; Social scientist, Associate Professor, part of the management team of IPHS at BAS',
    image: '/static/team/tanya.png',
    linkedin: 'https://www.linkedin.com/in/stoyanka-cherkezova-mateva-676520b9'
  },
  {
    firstName: 'Dobrin',
    lastName: 'Stefanov',
    title: 'Senior Graphic Designer',
    description: '12+ years of experience in UI/UX, Managing Partner at Intera Digital',
    image: '/static/team/dobrin.jpg',
    linkedin: 'https://www.linkedin.com/in/dobrin-stefanov/'
  },
  {
    firstName: 'Stefani',
    lastName: 'Dimitrova',
    title: 'Marketing Expert',
    description: '8+ years of marketing experience; brand strategies for growth of companies with contribution; Marketing strategies for startups',
    image: '/static/team/stefani.jpg',
    linkedin: 'https://www.linkedin.com/in/stefani-dimitrova/'
  },
  {
    firstName: 'Anna',
    lastName: 'Joukivskaia',
    title: 'Psychotherapist-Counselor',
    description: 'Certified family therapist, member of the board of the Bulgarian Association of Family Therapy. Manager of the psychological support program at the Single Step Foundation.',
    image: '/static/team/Anna-Joukivskaia.jpg',
    linkedin: 'https://www.linkedin.com/in/anna-joukivskaia-gmbpss-8437503a/'
  },
  {
    firstName: 'Pablo',
    lastName: 'McCabe',
    title: 'Advisor',
    description: 'Former Vice President at Talkspace - a leading psychological platform in America',
    image: '/static/team/pablo.jpeg',
    linkedin: 'https://www.linkedin.com/in/pablo-mccabe-9974a41/'
  },
  {
    firstName: 'Krasimir',
    lastName: 'Kehayov',
    title: 'Financial Advisor',
    description: 'Partner at DYNAX Invest, former analyst at Goldman Sachs and startup scout at Innovation Capital.',
    image: '/static/team/krasi.jpeg',
    linkedin: 'https://www.linkedin.com/in/krasimirkehayov/'
  }
];

// Use watcher and onMounted to reactively select the appropriate team members based on locale
import { onMounted, watch } from 'vue';

// Initialize with a ref that will be updated in onMounted and when locale changes
const teamMembers = ref(locale.value === 'bg' ? teamMembersBg : teamMembersEn);

// Update team members when locale changes
watch(() => locale.value, (newLocale) => {
  teamMembers.value = newLocale === 'bg' ? teamMembersBg : teamMembersEn;
  updateAdvisoryMembers();
});

// Ensure correct language is loaded initially
onMounted(() => {
  teamMembers.value = locale.value === 'bg' ? teamMembersBg : teamMembersEn;
  updateAdvisoryMembers();
});

// Advisory members data - reactive to language changes
const advisoryMembers = ref([]);

// Function to update advisory members based on current language
const updateAdvisoryMembers = () => {
  advisoryMembers.value = [
    {
      firstName: t('about-team-member-1-first-name'),
      lastName: t('about-team-member-1-last-name'),
      title: t('about-team-member-1-title'),
      description: t('about-team-member-1-description'),
      image: '/static/team/pb.jpg',
    },
    {
      firstName: t('about-team-member-2-first-name'),
      lastName: t('about-team-member-2-last-name'),
      title: t('about-team-member-2-title'),
      description: t('about-team-member-2-description'),
      image: '/static/team/mm.jpg',
      linkedin: ''
    },
    {
      firstName: t('about-team-member-3-first-name'),
      lastName: t('about-team-member-3-last-name'),
      title: t('about-team-member-3-title'),
      description: t('about-team-member-3-description'),
      image: '/static/team/fg.jpg',
      linkedin: ''
    },
    {
      firstName: t('about-team-member-4-first-name'),
      lastName: t('about-team-member-4-last-name'),
      title: t('about-team-member-4-title'),
      description: t('about-team-member-4-description'),
      image: '/static/team/ta.png',
      linkedin: ''
    },
    {
      firstName: t('about-team-member-5-first-name'),
      lastName: t('about-team-member-5-last-name'),
      title: t('about-team-member-5-title'),
      description: t('about-team-member-5-description'),
      image: '/static/team/gergana-markova.jpg',
      linkedin: ''
    },
    {
      firstName: t('about-team-member-6-first-name'),
      lastName: t('about-team-member-6-last-name'),
      title: t('about-team-member-6-title'),
      description: t('about-team-member-6-description'),
      image: '/static/team/violeta.png',
      linkedin: ''
    },
    {
      firstName: t('about-team-member-7-first-name'),
      lastName: t('about-team-member-7-last-name'),
      title: t('about-team-member-7-title'),
      description: t('about-team-member-7-description'),
      image: '/static/team/Lubomir_Draganov.jpg',
      linkedin: ''
    },
    {
      firstName: t('about-team-member-8-first-name'),
      lastName: t('about-team-member-8-last-name'),
      title: t('about-team-member-8-title'),
      description: t('about-team-member-8-description'),
      image: '/static/team/Zdravka.jpg',
      linkedin: ''
    },
  ];
};

const helpResources = [
  {
    title: 'kabinet.bg',
    content: 'Спешна психотерапевтична помощ и емоционална подкрепа',
    link: 'https://kabinet.bg/',
    phone: '+35980020202'
  },
  {
    title: 'Национална асоциация „Подкрепа за кърмене“',
    content: 'Оказваме помощ на майките за постигане на успешно и удовлетворително кърмене',
    link: 'https://podkrepazakarmene.com',
    phone: '+359896419488'
  },
  {
    title: 'Психотерапевти',
    content: 'Регистър на психотерапевтите към Българска асоциация по психотерапия',
    link: 'https://psychotherapy-bg.org/',
    phone: ''
  },
  {
    title: 'Психлози',
    content: 'Регистър на психолозите към Дружеството на психолозите в Република България',
    link: 'http://psychology-bg.org/%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D1%87%D0%B5%D0%BD-%D1%80%D0%B5%D0%B3%D0%B8%D1%81%D1%82%D1%8A%D1%80-%D0%BD%D0%B0-%D0%BF%D1%81%D0%B8%D1%85%D0%BE%D0%BB%D0%BE%D0%B7%D0%B8%D1%82%D0%B5-2019-2020/',
    phone: ''
  },
  {
    title: 'Психиатри',
    content: 'Списък с психиатри към Български лекарски съюз',
    link: 'https://blsbg.eu/bg/medics/search',
    phone: ''
  },
  {
    title: 'Фондация "Асоциация Анимус"',
    content: 'Фондация "Асоциация Анимус" - Помощ и подкрепа в случаи на домашно насилие. Националната гореща линия за пострадали от насилие жени и деца',
    link: 'https://www.animusassociation.org',
    phone: '+35929835405'
  },
  {
    title: '',
    content: 'Фондация "Асоциация Анимус" - Помощ и подкрепа в случаи на домашно насилие. Националната гореща линия за пострадали от насилие жени и деца',
    link: 'https://animusassociation.org/za-fondaciata/partniori/sluzhbi-organizacii-programi/',
    phone: '',
  }
];
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.help-title > div {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: $color-purple;
}

.header-video {
  border-radius: 20px;
}
</style>
